const mapConfig = {
  key: 'a93ef14309dab1f6b5e72f0d2235ed74',
  securityJsCode: 'dd395dcafbf5777e7efae751fe2c590a'
}

if (typeof window !== 'undefined') {
  window.mapConfig = mapConfig
  window._AMapSecurityConfig = {
    securityJsCode: mapConfig.securityJsCode
  }
}

export function loadAMap() {
  // 已有 AMap：直接返回
  if (window.AMap) {
    return Promise.resolve(window.AMap)
  }
  // 已有加载中 Promise：复用之，避免重复注入脚本
  if (window._AMapLoadingPromise) {
    return window._AMapLoadingPromise
  }

  window._AMapLoadingPromise = new Promise((resolve, reject) => {
    if (window._AMapSecurityConfig) {
      window._AMapSecurityConfig.securityJsCode = mapConfig.securityJsCode
    } else {
      window._AMapSecurityConfig = {
        securityJsCode: mapConfig.securityJsCode
      }
    }

    const script = document.createElement('script')
    script.src = `https://webapi.amap.com/maps?v=2.0&key=${mapConfig.key}`
    script.onload = () => {
      const uiScript = document.createElement('script')
      uiScript.src = 'https://webapi.amap.com/ui/1.1/main.js'
      uiScript.onload = () => {
        window.AMapConfig = mapConfig
        window._AMapLoadingPromise = null
        resolve(window.AMap)
      }
      uiScript.onerror = () => {
        window._AMapLoadingPromise = null
        reject(new Error('高德地图 UI 加载失败'))
      }
      document.head.appendChild(uiScript)
    }
    script.onerror = () => {
      window._AMapLoadingPromise = null
      reject(new Error('高德地图 API 加载失败'))
    }
    document.head.appendChild(script)
  })

  return window._AMapLoadingPromise
}

export default mapConfig
